import * as actionTypes from '../actions/actionTypes'

const initialState = {
  invoice : {
    invoiceNumber : null,
    currency : null,
    total : null,
    descriptionSuccess : ""
  },
}

const invoiceReducer = (state = initialState, actions) =>{
  let invoiceUpdate
  switch(actions.type){
      case actionTypes.INVOICE_FETCHING_SUCCESS:
        invoiceUpdate = {
          invoiceNumber : actions.invoiceNumber,
          currency : actions.currency,
          total : actions.total,
          descriptionSuccess : actions.descriptionSuccess }
        return {
          ...state,
          invoice : {...invoiceUpdate}
        }
      case actionTypes.INVOICE_PAY_SUCCESS:
        invoiceUpdate = state.invoice
        invoiceUpdate.descriptionSuccess = actions.descriptionSuccess
        return {
          ...state,
          invoice : {...invoiceUpdate}
        }
      case actionTypes.INVOICE_RESET_STATE:
       invoiceUpdate = {
          invoiceNumber : null,
          currency : null,
          total : null}
        return {
          ...state,
          invoice : {...invoiceUpdate}
        }
      default:
        return state
    }
}

export default invoiceReducer



// WEBPACK FOOTER //
// ./src/store/reducers/invoiceReducer.js